import ReportsExpShareCom from "./reports/ReportsExpShareCom";

function Report() {
  const data = [
    // { title: "Total Expenditure by Economic", value: "total_ex_by_eco" },
    { title: "Expenditure by MDA", value: "expenditure_by_mda" },
    { title: "MDA (Perssonnel)", value: "expenditure_by_mda_personnel" },
    { title: "MDA (Overhead)", value: "expenditure_by_mda_overhead" },
    { title: "MDA (Total Rucurrent)", value: "expenditure_by_mda_total_recurrent" },
    { title: "MDA (Capital)", value: "expenditure_by_mda_capital" },
    { title: "Expenditure by Department", value: "expenditure_by_department" },
  ];
  return (
    <ReportsExpShareCom
      type="expenditure_by_mda"
      title="Expenditure by MDA"
      route="/reports"
      options={data}
    />
  );
}

export default Report;
